export default "__VITE_ASSET__DXgs2E3E__"